import React from "react";
import Menu from "@material-ui/core/Menu";
import { MenuStyled } from "./styles";

export default ({ isStyled, ...props }) => {
	return <>{isStyled ? <MenuStyled elevation={0} {...props} /> : <Menu elevation={0} {...props} />}</>;
};
